import { render, staticRenderFns } from "./TreeInfoCategories.vue?vue&type=template&id=957a6a90&"
import script from "./TreeInfoCategories.vue?vue&type=script&lang=js&"
export * from "./TreeInfoCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('957a6a90')) {
      api.createRecord('957a6a90', component.options)
    } else {
      api.reload('957a6a90', component.options)
    }
    module.hot.accept("./TreeInfoCategories.vue?vue&type=template&id=957a6a90&", function () {
      api.rerender('957a6a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/infoCategories/tree/TreeInfoCategories.vue"
export default component.exports